<template>
  <div class="apiToolPage">
    <div class="content-box">
      <div class="content-body">
        <div class="page-title">API调试台和签名工具</div>
        <el-form ref="form" :model="form" label-width="80px">
          <el-form-item label="请求环境">
            <el-radio-group v-model="form.env" @change="envChange">
              <el-radio :label=1>测试环境</el-radio>
              <el-radio :label=2>正式环境</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="应用名称">
            <el-select v-model="form.app" placeholder="请选择应用" @click.native="getAppList">
              <el-option v-for="item in appList" :key="item.id" :label="item.app_name" :value="item.id"
                         @click.native="appChange(item)"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="app_secret">
            <el-input v-model="form.app_secret" style="width: 295px"
                      @change="appSecretChange(form.app_secret)"></el-input>
          </el-form-item>

          <el-form-item label="业务分类">
            <el-select v-model="form.business" placeholder="请选择业务分类" @click.native="getBusinessList">
              <el-option v-for="item in businessList" :key="item.id" :label="item.business_name" :value="item.id"
                         @click.native="businessChange(item)"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="接口名称" class="interface_name-item">
            <el-select v-model="form.interface" placeholder="请选择接口" @click.native="getInterfaceList">
              <el-option v-for="item in interfaceList" :key="item.id" :label="item.interface_name" :value="item.id"
                         @click.native="interfaceChange(item)"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="access_token" class="access_token-item">
            <el-input v-model="form.access_token" style="width: 295px" :disabled="!form.is_auth"
                      @change="accessTokenChange(form.access_token)"></el-input>
          </el-form-item>

          <el-form-item label="nonce_str" class="nonce_str-item">
            <el-input v-model="form.nonce_str" style="width: 295px"></el-input>
            <el-button @click="getNonceStr">生成随机串</el-button>
          </el-form-item>

          <el-form-item label="timestamp" class="timestamp-item">
            <el-input v-model="form.timestamp" style="width: 295px"></el-input>
            <el-button @click="getCurTimeStamp">生成时间戳</el-button>
          </el-form-item>

          <el-form-item label="请求地址">
            <el-input v-model="form.request_url" style="width: 295px" :disabled="true"></el-input>
          </el-form-item>

          <el-form-item label="请求数据">
            <vue-json-editor
                v-model="form.request_body_data"
                :showBtns="false"
                :mode="'code'"
                lang="zh"
                @json-change="onJsonChange"
                @has-error="onError"
            />
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="onSubmit">发送</el-button>
            <el-button type="primary" @click="onSignature">生成签名</el-button>
          </el-form-item>


          <div v-show="is_sign">
            <div class="signature-body">
              <div class="sign-title-A">
                <strong>signature:</strong> <span class="sign-content-A">{{ this.md5_sign }}</span>
              </div>
              <div class="sign-title-B">
                <strong>签名原串:</strong> <span class="sign-content-B">{{ this.sign_param }}</span>
              </div>
            </div>
          </div>

          <div class="codeView" v-show="is_sign">
            <el-tabs type="card" v-model="tabsActive">
              <el-tab-pane label="Java源码示例" name="first">
           <pre style="height: 77%;padding-left: 0;margin: auto;width: 100%">
              <code class="language-java line-numbers" v-text="javaCode"></code>
          </pre>
              </el-tab-pane>
              <el-tab-pane label="PHP源码示例" name="second">
           <pre style="height: 77%;padding-left: 0;margin: auto;width: 100%">
              <code class="language-php line-numbers" v-text="phpCode"></code>
          </pre>
              </el-tab-pane>
            </el-tabs>
          </div>

          <template v-if="this.is_response">
            <el-form-item label="响应数据">
              <vue-json-editor
                  v-model="form.response_body_data"
                  :showBtns="false"
                  :mode="'code'"
                  lang="zh"
              />
            </el-form-item>
          </template>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import {getCurTimeStamp, getNonceStr, getParam, getMd5Sign, isJson} from "../../assets/js/common";
import vueJsonEditor from 'vue-json-editor';
import axios from "axios";

export default {
  name: "apiToolPage",
  data() {
    return {
      tabsActive: "first",
      form: {
        env: 1,
        name: '',
        business: '',
        interface: '',
        type: [],
        desc: '',
        nonce_str: '',
        timestamp: '',
        request_url: '',
        app: '',
        app_secret: '',
        app_id: 0,
        app_key: 0,
        business_id: 0,
        interface_id: 0,
        is_auth: false,
        request_virtual: '',
        access_token: '',
        api_method: '',
        request_body_data: '',
        response_body_data: ''
      },
      curEnv: '',
      is_sign: false,
      signature_after: '',  //签名
      signature_before: '', //签名原串
      request_example: '',
      appList: [],
      businessList: [],
      interfaceList: [],
      jsonError: false,
      md5_sign: '',
      sign_param: '',
      is_response: false,
      is_sandbox: true,
      javaCode: `    /**
                 * 生成签名
                 *
                 * @param map 签名参数
                 * @param secret 应用密钥
                 * @return
                 */
                 public static String getSignToken(Map<String, Object> map, String secret) {
                    String result = "";
                    try {
                        List<Map.Entry<String, Object>> infoIds =
                            new ArrayList<Map.Entry<String, Object>>(map.entrySet());
                        // 对所有传入参数按照字段名的 ASCII 码从小到大排序（字典序）
                        Collections.sort(infoIds, new Comparator<Map.Entry<String, Object>>() {
                            @Override
                            public int compare(Map.Entry<String, Object> o1, Map.Entry<String, Object> o2) {
                                return (o1.getKey()).compareTo(o2.getKey());
                            }
                        });
                        // 构造签名键值对的格式
                        StringBuilder sb = new StringBuilder();
                        for (Map.Entry<String, Object> item : infoIds) {
                            String key = item.getKey();
                            Object val = item.getValue();
                            //验签需忽略signature参数
                            if ("signature".equals(key)) {
                                continue;
                            }
                            if (val instanceof Map) {
                            val = JsonUtil.toJSONString(val);
                            }
                            sb.append(key).append("=").append(val).append("&");
                        }

                        result = sb.substring(0, sb.length() - 1) + secret;
                        //进行MD5加密
                        result = bit32(result).toLowerCase();
                    } catch (Exception e) {
                        return null;
                    }
                    return result;
                }`,
      phpCode: `   /**
                * 生成签名
                *
                * @param array $data 待签名数组
                * @param string $appSecret 应用密钥
                * @return string 返回值
                */
                function getSignToken(array $data = [],string $appSecret = '') {
                  try {
                    if (!empty($data) && !is_array($data)) {
                      return null;
                    }

                    //验签需忽略signature参数
                    unset($data['signature']);
                    //数组的key值进行升序
                    ksort($data);

                    //组装数组
                    $temp = [];
                    foreach ($data as $key => $item) {
                      array_push($temp, "{$key}={$item}");
                    }

                    //数组组合成字符串
                    $str = implode('&', $temp) . $appSecret;
                    //返回32位小写md5签名
                    return md5($str);
                  } catch (Exception $e) {
                    return null;
                  }
                }`
    }

  },
  components: {
    vueJsonEditor
  },
  mounted() {
    this.init();
    Prism.highlightAll();//代码高亮渲染函数
  },
  methods: {
    init() {
      //初始化，默认显示测试环境网关域名
      this.getSandboxGatewayUrl()
      this.getNonceStr()
      this.getCurTimeStamp()
    },
    IsJsonValid(request_data) {
      if (!isJson(request_data)) {
        throw '请求数据不是合法json';
      }
    },
    IsJsonError() {
      if (this.jsonError) {
        throw '请求数据有误，请检查';
      }
    },
    IsDataEmpty(request_data) {
      if (!request_data) {
        throw '请求数据不能为空';
      }
    },
    IsAccessTokenEmpty(request_data) {
      if (this.form.is_auth && !request_data.access_token) {
        throw 'access_token不能为空';
      }
    },
    IsAppKeyEmpty() {
      if (!this.form.app_secret && ('app_secret' in this.form.request_body_data)) {
        this.form.app_secret = this.form.request_body_data.app_secret
      } else if (!this.form.app_secret) {
        throw 'app_secret不能为空';
      }
    },
    onSubmitValidator(request_data) {
      this.IsJsonValid(request_data)
      this.IsJsonError()
      this.IsDataEmpty(request_data)
      this.IsAccessTokenEmpty(request_data)
    },
    onSubmit() {
      let request_data = this.form.request_body_data;
      try {
        this.onSubmitValidator(request_data)
      } catch (e) {
        this.$message.error(e);
        return;
      }
      this.getSignature(request_data, this.form.app_secret)
      this.is_response = true
      this.is_sign = false;
      request_data.signature = this.md5_sign;
      axios.post(this.getGatewayPath(this.is_sandbox), request_data, {
        headers: {
          'from': 'open',   //标记来自于门户的请求
          'hll-appid': 'bfe-hop-nirvana-svc'
        }
      }).then(res => {
        this.hideCommonLoading();
        this.is_response = true
        this.form.response_body_data = res.data
      }).catch((e) => {
      }).finally(
          request_data.signature = undefined
      );
    },
    onSignature() {
      Prism.highlightAll();
      this.is_response = false;
      let request_data = this.form.request_body_data;
      try {
        this.IsJsonError();
        this.IsDataEmpty(request_data)
        this.IsAppKeyEmpty()
      } catch (e) {
        this.$message.error(e)
        return;
      }
      this.is_sign = true;
      this.getSignature(request_data, this.form.app_secret)
    },
    getSignature(data, appSecret) {
      this.sign_param = getParam(data, appSecret)
      this.md5_sign = getMd5Sign(data, appSecret)
      console.log('md5签名：' + this.md5_sign)
    },
    getNonceStr() {
      this.form.nonce_str = getNonceStr();
      this.changeJsonData('nonce_str', this.form.nonce_str)
    },
    getCurTimeStamp() {
      this.form.timestamp = getCurTimeStamp();
      this.changeJsonData('timestamp', this.form.timestamp)
    },
    accessTokenChange(accessToken) {
      this.form.access_token = accessToken
      this.changeJsonData('access_token', this.form.access_token)
    },
    appSecretChange(appSecret) {
      this.form.app_secret = appSecret
    },
    envChange() {
      // env:1 测试环境 env:2 正式环境
      if (this.form.env === 1) {
        this.is_sandbox = true;
        this.getSandboxGatewayUrl();
      } else {
        this.is_sandbox = false;
        this.getCurGatewayUrl();
      }
    },
    getSandboxGatewayUrl() {
      let sandboxGatewayEnv = this.$config.sandboxGatewayEnv;
      this.form.request_url = `https://openapi${sandboxGatewayEnv}.huolala.cn/v1`
    },
    getCurGatewayUrl() {
      let envStr = this.$config.envStr;
      this.form.request_url = `https://openapi${envStr}.huolala.cn/v1`
    },
    getAppList() {
      this.$axios.get(this.getRequestPath(this.is_sandbox) + "/ajax/api/tool/app/list").then(res => {
        this.appList = res.data.data;
      });
    },
    appChange(item) {
      this.form.app_secret = item.app_secret;
      this.form.app_id = item.id;
      this.form.app_key = item.app_key
      this.form.request_body_data = ''
    },
    getBusinessList() {
      this.$axios.get(this.getRequestPath(this.is_sandbox) + "/ajax/api/tool/app/business/category", {
        params: {
          app_id: this.form.app_id
        }
      }).then(res => {
        this.businessList = res.data.data;
      });
    },
    businessChange(item) {
      this.form.business_id = item.id;
    },
    getInterfaceList() {
      this.$axios.get(this.getRequestPath(this.is_sandbox) + "/ajax/api/tool/app/interface/list", {
        params: {
          app_id: this.form.app_id,
          business_id: this.form.business_id
        }
      }).then(res => {
        this.interfaceList = res.data.data;
      });
    },
    interfaceChange(item) {
      this.jsonError = false
      this.form.is_auth = item.is_auth;
      this.form.api_method = item.request_virtual;
      this.combineJsonData(item)
    },
    combineJsonData(item) {
      if (item.request_example) {
        if (Object.prototype.toString.call(JSON.parse(item.request_example)) === '[object Object]') {
          let data = JSON.parse(item.request_example)

          data.api_method = this.form.api_method
          data.access_token = this.form.access_token
          data.app_key = this.form.app_key
          data.api_version = '1.0'
          data.nonce_str = this.form.nonce_str
          data.timestamp = parseInt(this.form.timestamp)
          this.form.request_body_data = data
        }
      } else {
        this.form.request_body_data = ''
      }
    },
    changeJsonData(type, ...value) {
      if (this.form.request_body_data) {
        if (type === 'nonce_str') {
          this.form.request_body_data.nonce_str = value[0]
        }
        if (type === 'timestamp') {
          this.form.request_body_data.timestamp = parseInt(value[0])
        }
        if (type === 'access_token') {
          this.form.request_body_data.access_token = value[0]
        }
      }
    },
    getRequestPath(sandbox) {
      return sandbox ? '/sandbox' : '';
    },
    getGatewayPath(sandbox) {
      let gatewayPath = sandbox ? '/sandbox/v1' : '/v1';
      console.log("path: " + gatewayPath)
      return gatewayPath;
    },
    onJsonChange() {
      this.jsonError = false
      // this.objToString()
    },
    onError() {
      this.jsonError = true
    },
    objToString() {
      //把对象转成字符串
      let data = this.form.request_body_data
      let keys = Object.keys(data).sort()
      for (var p = 0; p < keys.length; p++) {
        let dataStr = data[keys[p]];
        if (typeof dataStr == 'object' && dataStr) {
          dataStr = JSON.stringify(dataStr)
          data[keys[p]] = dataStr;
        }
      }
    }
  },
  watch: {
    'form.app_id': function () {
      this.form.business = ''
      this.form.interface = ''
    },
    'form.env': function () {
      this.form.business = ''
      this.businessList = []
      this.form.interface = ''
      this.interfaceList = []
      this.form.app = ''
      this.appList = []
      this.form.app_secret = ''
    },
    'form.business_id': function () {
      this.form.interface = ''
    },
    'form.interface': function () {
      this.form.access_token = ''
    },
    'form.javaCode': function () {
      Prism.highlightAll()
    },
    'form.request_body_data': function () {
      this.objToString();
    }
  }
}
</script>

<style lang="scss">

.apiToolPage {
  min-width: 1180px;
  width: 60%;
  padding: 20px 20px 30px 20px;
  margin: 0 auto;


  .content-box {
    position: relative;
    min-height: 300px;
    margin-top: 25px;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);

    .content-body {
      padding: 0 0 0 0;
    }

    .el-form {
      padding: 5px 340px 10px 100px;
    }
  }
}


.access_token-item .el-form-item__label {
  margin-left: -7px;
}

.nonce_str-item .el-button {
  margin-left: 18px;
}

.timestamp-item .el-button {
  margin-left: 18px;
}

.request_body_data-item .el-textarea__inner {
  width: 900px;
  height: 260px;
}

.api-content-box {
  width: 100%;
  padding: 22px 25px 25px 270px;
  box-sizing: border-box;

  .part-title {
    width: 100%;
    line-height: 35px;
    color: #424456;
    font-size: 15px;
    padding-left: 2px;
    border-bottom: 1px solid #F2F2F2;
    font-weight: bold;
  }

  .part-content {
    width: 100%;
    padding: 15px 3px 20px 5px;
    box-sizing: border-box;
  }

  .json-box {
    padding: 15px;
    max-height: 520px;
    font-size: 13px;
    line-height: 15px;
    background: #F7F7F7;
    box-sizing: border-box;
    overflow: auto;
  }

  .info-row {
    color: #212121;
    font-size: 14px;
    line-height: 24px;

    .info-label {
      display: inline-block;
      width: 90px;
      vertical-align: top;
    }

    .info-value {
      display: inline-block;
      width: 600px;
      vertical-align: top;
      color: #666;
    }

    .info-tag {
      display: inline-block;
      width: 60px;
      height: 24px;
      font-size: 12px;
      line-height: 24px;
      text-align: center;
      background: #E4E6F4;
      border-radius: 2px;
      transform: scale(.88);
      transform-origin: left;
      margin-right: -5px;
    }

    .tag-position-top {
      position: relative;
      top: -1px;
    }
  }


}

.textarea {
  width: 100%;
  min-height: 120px;
  max-height: 300px;
  margin-left: auto;
  margin-right: auto;
  padding: 3px;
  outline: 0;
  border: 1px solid #a0b3d6;
  font-size: 12px;
  line-height: 24px;
  word-wrap: break-word;
  overflow-x: hidden;
  overflow-y: auto;
  //border-color: rgba(82, 168, 236, 0.8);
  //box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.1), 0 0 8px rgba(82, 168, 236, 0.6);
}

.jsoneditor-poweredBy {
  display: none;
}

div.jsoneditor {
  color: #1A1A1A;
  border: 1px solid #F16222;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  padding: 0;
  line-height: 100%;
}

div.jsoneditor-menu {
  width: 100%;
  height: 35px;
  padding: 2px;
  margin: 0;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: white;
  background-color: #F16222;
  border-bottom: 1px solid #F16222;
}


.signature-body {
  min-height: 200px;
  width: 927px;
  margin-left: 80px;
  margin-top: 20px;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);
  color: #000000;
  background-color: #F0F0F0;

  .sign-title-A {
    padding: 22px 0 0 25px;
  }

  .sign-title-B {
    padding: 22px 0 0 35px;
  }

  .sign-content-A {
    margin: 0 0 0 15px;
  }

  .sign-content-B {
    margin: -21px 0 0 80px;
    word-break: normal;
    width: auto;
    display: block;
    white-space: pre-wrap;
    word-wrap: break-word;
    overflow: hidden;
  }

}

.api-content-box {
  width: 100%;
  padding: 22px 25px 25px 270px;
  box-sizing: border-box;

  .part-content {
    width: 100%;
    padding: 15px 3px 20px 5px;
    box-sizing: border-box;
  }
}

.response-body {
  min-height: 200px;
  width: 927px;
  margin-left: -2px;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);
  color: #000000;
  background-color: #F0F0F0;

}

.codeView {
  margin: 20px -265px 0px 80px;
}

textarea.jsoneditor-text, .ace-jsoneditor {
  min-height: 200px
}


</style>


// WEBPACK FOOTER //
// src/components/help/apitool.vue